import styled from 'styled-components';
import { CopyFineprint } from '../../atoms/Copytext';
import getSpacing from '~/helpers/getSpacing';
import Picture from '../../atoms/Picture';
import getImageProperties from '~/helpers/getImageProperties';

const StyledImageContainer = styled.div`
  width: ${(props) => (props.fullWidth ? '100%' : 'initial')};
  margin: ${(props) => (props.fullWidth ? '' : 'auto')};
  height: ${(props) => (props.fullHeight ? '100%' : 'initial')};
`;

const StyledCopyFineprint = styled(CopyFineprint)`
  display: block;

  ${(props) => getSpacing(props.theme.spacingMap.img.text, 'mtop')}
`;

/**
 * Image component displays an image with optional caption and full width option.
 *
 * @param {ImageProps} props - The properties for the Image component.
 * @returns {React.ReactElement} The rendered Image component.
 */
const Image = ({
  className,
  alt = '',
  title = '',
  url,
  caption,
  fullWidth = true,
  fullHeight = false,
}) => {
  return (
    <StyledImageContainer
      className={className}
      fullWidth={fullWidth}
      fullHeight={fullHeight}
    >
      <Picture
        urls={getImageProperties({ xl: url, md: url, xs: url }, 'image')}
        alt={alt}
        title={title}
        heroEVP={fullHeight}
      />
      {caption && <StyledCopyFineprint>{caption}</StyledCopyFineprint>}
    </StyledImageContainer>
  );
};

export default Image;
